import { useContext } from 'react';

import { UserSettingsContext } from './user-settings-context';

export const useOpenSettings = () => {
  const { openSettings } = useContext(UserSettingsContext);

  return openSettings;
};
